import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeToFront = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14252 5.38912C5.85366 5.686 5.86017 6.16083 6.15704 6.44968C6.45392 6.73854 6.92875 6.73203 7.2176 6.43516L9.25001 4.34631V14.9425C9.25001 15.3567 9.58579 15.6925 10 15.6925C10.4142 15.6925 10.75 15.3567 10.75 14.9425L10.75 4.34631L12.7824 6.43516C13.0713 6.73203 13.5461 6.73854 13.843 6.44968C14.1399 6.16083 14.1464 5.686 13.8575 5.38912L10.5375 1.97698C10.3964 1.83186 10.2025 1.75 10 1.75C9.79753 1.75 9.60366 1.83186 9.46246 1.97698L6.14252 5.38912ZM7.5 7.36024L2.3698 9.92534C1.44849 10.386 1.4485 11.7008 2.3698 12.1614L3.5588 12.7559L2.3698 13.3504C1.44849 13.8111 1.4485 15.1258 2.3698 15.5865L9.21737 19.0103C9.71005 19.2566 10.2899 19.2566 10.7826 19.0103L17.6302 15.5865C18.5515 15.1258 18.5515 13.8111 17.6302 13.3504L16.4412 12.7559L17.6302 12.1614C18.5515 11.7007 18.5515 10.386 17.6302 9.92534L12.5 7.36024V9.03729L16.5122 11.0434L12.5 13.0495V14.7265L14.7641 13.5944L16.5122 14.4684L10.1118 17.6686C10.0414 17.7038 9.95858 17.7038 9.88819 17.6686L3.48784 14.4684L5.23585 13.5944L7.5 14.7265V13.0495L3.48784 11.0434L7.5 9.03729V7.36024Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrangeToFront
